module.exports = __webpack_public_path__ + "static/media/pexels-bongkarn-thanyakij-3843338.fc9b3f35.jpg";